import { ApiType } from "@gymflow/common";
import { useInfiniteQuery } from "@tanstack/react-query";

import { creditPackAsMemberQueryKeys } from "./creditPackAsMemberQueryKeys";

export const useInfiniteQuerySessionPackSubscriptionCurrentAsMember = ({
  api,
  enabled,
}: {
  api: ApiType;
  enabled: boolean;
}) =>
  useInfiniteQuery({
    queryKey:
      creditPackAsMemberQueryKeys.sessionPackSubscriptionCurrentAsMember(),
    queryFn: async ({ pageParam }: { pageParam?: string }) =>
      (
        await api.customerCreditPackApi.sessionPackSubscriptionCurrent({
          nextPageToken: pageParam,
        })
      ).data,
    getNextPageParam: (lastPage) => lastPage?.nextPageToken,
    enabled,
    initialPageParam: undefined,
  });
